export default __webpack_public_path__ + "static/media/open_folder.15594e7f.svg";